import type { FileKey } from '@/types/bundle'

// Friendly section names for all 7 file_keys - legalflow-idp/docs/
// CONFIG_REFERENCE.md's "file_key vocabulary" table (PRD 21's FILE_KEYS
// mapping). Shared across the Dashboard (recent-activity/draft-pending
// labels) and the Diff & Validation screen (per-file diff block headers).
const FILE_KEY_LABELS: Record<FileKey, string> = {
  global_defaults: 'Global Defaults',
  product_types: 'Products',
  document_types: 'Documents',
  extractors: 'Extractors',
  lookup_table: 'Lookup Table',
  clients: 'Clients',
  chunking_profiles: 'Chunking Profiles',
}

export function fileKeyLabel(fileKey: FileKey): string {
  return FILE_KEY_LABELS[fileKey] ?? fileKey
}
